import { Box, Typography } from '@mui/material';
import React from 'react';
import { useLocation } from 'react-router';

// Breadcrumb Component
interface BreadcrumbProps {
  items: string[];
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ items }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
    {items.map((item, index) => (
      <React.Fragment key={item}>
        <Typography
          variant="body2"
          color={index === items.length - 1 ? 'text.primary' : 'text.secondary'}
          fontWeight={index === items.length - 1 ? 600 : 400}
        >
          {item}
        </Typography>
        {index < items.length - 1 && (
          <Typography variant="body2" color="text.secondary">
            {'>'}
          </Typography>
        )}
      </React.Fragment>
    ))}
  </Box>
);

const PlaceholderPage: React.FC = () => {
  const location = useLocation();

  // Extract page name from path
  const pathParts = location.pathname.split('/').filter(Boolean);
  const pageName =
    pathParts[pathParts.length - 1]?.replace(/-/g, ' ')?.replace(/\b\w/g, (c) => c.toUpperCase()) ||
    'Page';

  const breadcrumbItems = [
    'Sunny Benefits',
    ...pathParts.slice(1).map((p) => p.replace(/-/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())),
  ];

  return (
    <Box sx={{ p: 3, bgcolor: '#F7F5F2', minHeight: '100%' }}>
      <Breadcrumb items={breadcrumbItems} />

      <Typography variant="h4" fontWeight={700} gutterBottom>
        {pageName}
      </Typography>
      <Typography variant="body2" color="text.secondary" mb={3}>
        As of Sep 8, 2025
      </Typography>

      <Box
        sx={{
          bgcolor: '#FFFFFF',
          borderRadius: 2,
          border: '1px solid #EFF0F0',
          p: 4,
          minHeight: 400,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography variant="h6" color="text.secondary">
          {pageName} - Coming Soon
        </Typography>
      </Box>
    </Box>
  );
};

export default PlaceholderPage;
